import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import {
  LevelType,
  MessageType,
  PxModalMessageService,
} from '@proximus/ng-common-components';
import { InternetProduct } from '@dch/products-business-logic';
import { OnDestroyHookDirective } from 'src/app/shared/hooks';
import { getPiiServiceId } from 'src/app/shared/pii/pii.utils';
import { GetProductDetails } from 'src/app/store/actions/product-details.actions';
import {
  ApplicationState,
  getProductDetailsTechnicalError,
  getSelectedProductDetails,
} from 'src/app/store/reducers';
import { getUsageProductFrom } from 'src/app/shared/usage/util';
import { Product as UsageProduct } from '@proximus/usage-business-logic';

declare let inception;

@Component({
  selector: 'mprd-internet-usage-pxsplus',
  templateUrl: './internet-usage-pxsplus.component.html',
})
export class InternetUsagePxsplusComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  selectedProduct: InternetProduct;
  hasError: boolean;
  usageProduct: UsageProduct;
  fragmentId: string;
  remainingDaysLabel: string;

  constructor(
    private store: Store<ApplicationState>,
    private route: ActivatedRoute,
    private pxModalMessageService: PxModalMessageService,
    private translationService: TranslationService,
    private inceptionService: InceptionService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadInternetDetails();
  }

  private loadInternetDetails() {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.addSubscription(
        this.store.select(getSelectedProductDetails).subscribe((value) => {
          if (value && value.internetProductDetails) {
            this.selectedProduct = value.internetProductDetails;
            this.usageProduct = getUsageProductFrom(this.selectedProduct);
          }
        }),
      );
      this.addSubscription(
        this.route.params.subscribe((params) => {
          this.store.dispatch(
            new GetProductDetails({
              productType: 'internet',
              serviceId,
            }),
          );
        }),
      );
      this.addSubscription(
        this.route.fragment.subscribe((fragment) => {
          this.fragmentId = fragment;
        }),
      );
      this.addSubscription(
        this.store
          .select(getProductDetailsTechnicalError)
          .subscribe((value) => {
            this.hasError = value !== null;
          }),
      );
    } else {
      this.hasError = true;
      this.pxModalMessageService.dispatchMessage(
        MessageType.Error,
        LevelType.Root,
        this.translationService.getTranslatedValueFor(
          'message.error.internet.settings.description',
        ),
        this.translationService.getTranslatedValueFor('message.error.title'),
        false,
        false,
        'technicalError',
      );
    }
  }
  usageInitializedWith(remainingDaysLabel: string) {
    if (remainingDaysLabel) {
      this.remainingDaysLabel = remainingDaysLabel;
      this.initMasonry();
      if (this.fragmentId) {
        this.inceptionService.scrollToElement('#' + this.fragmentId);
      }
    }
  }
  initMasonry() {
    setTimeout(() => {
      inception.masonry('[data-masonry-container]');
    });
  }
}
